import React, { FC } from 'react';

import { ScaleLinear } from 'd3';

import styled from 'styled-components';

const StyledLine = styled.line`
  opacity: 0.5;
  stroke-width: 2;
  stroke: #4d9edc;
  fill: none;
  stroke-dasharray: 4;
`;

interface Props {
  value: number;
  xScale: ScaleLinear<number, number>;
  innerHeight: number;
}

const Line: FC<Props> = ({ value, xScale, innerHeight }) => (
  <StyledLine x1={xScale(value)} y1="0" x2={xScale(value)} y2={innerHeight} />
);

export default Line;
